import CustomRequirement from "../Home/CustomRequirements";

const SourceItBrandIt = () => {
  const categories = [
    "Apparel & Uniforms",
    "Home Decor",
    "Custom Gifting",
    "Jewelry & Accessories",
    "Cosmetics & Wellness",
    "Awards & Merchandise",
    "Custom Requirements",
  ];

  return (
    <section className="w-full bg-gradient-to-br from-[#F9F9F9] via-[#F6F3F2] to-[#F0E6E6] py-20 px-6 md:px-12 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        {/* 
            1. Header Section
    */}
        <div className="mb-16">
          <h2 className="text-4xl md:text-5xl font-normal leading-[1.2] tracking-tight">
            <span className="text-black">If We Can Source It, </span>
            <span className="text-[#737373]">
              You <br className="hidden md:block" /> Can Brand It.
            </span>
          </h2>
        </div>

        {/* 
            2. Content Grid (Image Left - List Right)
        */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          {/* Left Column: Image with Floating UI  */}
          <div className="relative order-2 lg:order-1">
            {/* Main Image Container */}
            <img
              src="./images/mandesk.png"
              alt="Entrepreneur working"
              className="w-full h-auto object-cover min-h-[400px] md:min-h-[500px]"
            />
          </div>

          {/*Right Column: Checklist */}
          <div className="flex flex-col justify-center order-1 lg:order-2">
            <ul className="space-y-5 md:space-y-7">
              {categories.map((item, index) => (
                <li
                  key={index}
                  className="flex items-center gap-4 group cursor-default"
                >
                  {/* Green Check Icon */}
                  <div className="flex-shrink-0 w-5 h-5 flex items-center justify-center">
                    <svg
                      className="w-5 h-5 text-green-500"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>

                  {/* Text */}
                  <span className="text-lg md:text-xl text-gray-900 font-normal tracking-wide">
                    {item}
                  </span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <CustomRequirement />
    </section>
  );
};

export default SourceItBrandIt;
